// extracted by mini-css-extract-plugin
export default {"form-errors":"RedErrorMessage_form-errors__sRurV"};